import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes, ROUTE_PATHS } from '../../shared/constants/app-routes';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordNavigationService {
  public currentStep = signal(1);

  constructor(private router: Router) {}

  setStep(step: number): void {
    this.currentStep.set(step);
  }

  handleBackNavigation(): boolean {
    const currentStep = this.currentStep();
    
    if (currentStep === 2) {
      this.setStep(1);
      return true; 
    } else if (currentStep === 1) {
      this.router.navigate([ROUTE_PATHS[AppRoutes.HOME]]);
      return true; 
    }
    
    return false; // No manejó la navegación
  }

  resetStep(): void {
    this.setStep(1);
  }
}

